'use client';

import { TIMEZONE_OPTIONS } from '../constants';
import { TimezoneSelectProps } from '../types';

const TimezoneSelect = ({
  value,
  onChange,
  disabled = false,
  className,
}: TimezoneSelectProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className={`form-control w-full ${className}`}>
      <label className="label">
        <span className="label-text">Timezone</span>
      </label>
      <select
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className="select select-bordered w-full">
        {TIMEZONE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimezoneSelect;
